export function isNull(val: any): val is null {
    return val === null;
}

export function isUndefined(val: any): val is undefined {
    return (typeof val === 'undefined');
}

export function isZero(val: any): val is 0 {
    return val === 0;
}

export function isEmptyArray(val: any): val is [] {
    return (Array.isArray(val) && (val.length === 0));
}

export function isEmptyString(val: any): val is '' {
    return val === '';
}

export function isNullOrUndefined(val: any): val is undefined | null {
    return isNull(val) || isUndefined(val);
}

export function isNullOrUndefinedOrZero(val: any): val is undefined | null | 0 {
    return isNull(val) || isUndefined(val) || isZero(val);
}

export function isNullOrUndefinedOrEmptyArray(val: any): val is undefined | null | [] {
    return isNull(val) || isUndefined(val) || isEmptyArray(val);
}

export function isNullOrUndefinedOrEmptyString(val: any): val is undefined | null | '' {
    return isNull(val) || isUndefined(val) || isEmptyString(val);
}

export function formatBytes(a:number,b=2){
    if (0===a) return"0 Bytes";
    const c = 0 > b ? 0 : b , d = Math.floor(Math.log(a)/Math.log(1024));
    return parseFloat((a/Math.pow(1024,d)).toFixed(c))+" "+["Bytes","KB","MB","GB","TB","PB","EB","ZB","YB"][d]}

export function decimalToRgb(decimal: number) {
    return {
        red: (decimal >> 16) & 0xff,
        green: (decimal >> 8) & 0xff,
        blue: decimal & 0xff,
    };
    //rgb(red,gree,blue)
}
export function convertColor(color:number) {
    return `rgb(${decimalToRgb(color).red}, ${decimalToRgb(color).green}, ${decimalToRgb(color).blue})`
}
export function RGB_Log_Shade(p:any,col:string){
    var i=parseInt,r=Math.round,[a,b,c,d]=col.split(","),P:any=p<0,t=P?0:p*255**2;
    P=P?1+p:1-p;
    return"rgb"+(d?"a(":"(")+r((P*i(a[3]==="a"?a.slice(5):a.slice(4))**2+t)**0.5)+","+r((P*i(b)**2+t)**0.5)+","+r((P*i(c)**2+t)**0.5)+(d?","+d:")");
}